<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    floating
    persistent
    mobile-breakpoint="1367"
    width="288"
  >
    <v-layout column>
      <center style="min-height:90px; align-items: center;justify-content: center;display: flex;">
        <v-img
          :src="logoImage"
          max-height="90px"
          max-width="240px"
          contain
        />
      </center>
      <v-divider />
      <v-list-item
        v-for="(link, i) in links"
        :key="i"
        :to="link.to"
        class="v-list-item"
      >
        <v-list-item-action>
          <IconCustom :name="link.icon" />
        </v-list-item-action>
        <v-list-item-title v-text="link.text" />
      </v-list-item>
      <div
        v-for="(config, i) in modules"
        :key="10+i"
      >
        <v-list-item
          v-if="!config.submenu"
          :to="'/modules/'+ config.path"
          class="v-list-item"
        >
          <v-list-item-action>
            <IconCustom :name="config.icon" />
          </v-list-item-action>
          <v-list-item-title v-text="config.name[$i18n.locale]" />
        </v-list-item>
        <v-list-group
          v-else
          :value="false"
          no-action
        >
          <template v-slot:prependIcon>
            <IconCustom :name="config.icon" />
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ config.name[$i18n.locale] }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(item, idx) in config.submenu"
            :key="idx"
            :to="`/modules/${config.path}/${item.path}`"
            class="v-list-item"
          >
            <v-list-item-title v-text="item.name[$i18n.locale]" />
          </v-list-item>
        </v-list-group>
      </div>
    </v-layout>
    <v-divider class="mt-6" />
  </v-navigation-drawer>
</template>

<script>

import { mapMutations, mapState, mapGetters } from "vuex";
import {getLogoUrl} from "@/utils/getLogo";
import IconCustom from "@/components/helper/IconCustom.vue";

export default {
  components: {IconCustom},
  data() {
    return {
      logoLight: this.$ls.get('config').logo_light_theme,
      logoDark: this.$ls.get('config').logo_dark_theme,
      links: [
        {
          to: "/dashboard",
          icon: "icn24_category",
          text: this.$i18n.t("drawer.dashboard"),
        },
        {
          to: "/whitelabels",
          icon: 'icn24_buildings',
          text: this.$t("drawer.whiteLabel"),
        },
        {
          to: "/users",
          icon: 'icn24_users',
          text: this.$t("drawer.users"),
        },
        {
          to: "/invoices",
          icon: 'icn24_receipt',
          text: this.$t("drawer.billing"),
        },
        {
          to: "/withdrawals",
          icon: 'icn24_upload',
          text: this.$t("drawer.withdrawals"),
        },
        {
          to: "/transactions",
          icon: 'icn24_swap_alt',
          text: this.$t("transactions.transactions"),
        }
      ],
      responsive: false
    };
  },
  computed: {
    ...mapState("app", ["image", "color", "pendingRequests"]),
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    logo() {
      return this.$vuetify.theme.dark ? this.logoDark : this.logoLight
    },
    logoImage() {
      const image = getLogoUrl(this.getWhiteLabel || {}, this.$vuetify.theme.dark || false) || this.logo
      if (this.getWhiteLabel  === undefined) {
        return null
      }
      return image
    },
    modules() {
      if (!this.getWhiteLabel) return null
      let modules = new Map()
      let result = []
      this.getWhiteLabel.modules.map(module => {
        if (module.public_config.menu 
            && module.public_config.menu.type == 'admin' 
            && module.public_config.menu.position == 'left') {
              if(module.public_config.menu.submenu) {
                module.public_config.menu.config.map(item => {
                  let newItem = item;
                  newItem.submenu = module.public_config.menu.submenu;
                  modules.set(item.path, newItem)
                })
              } else {
                module.public_config.menu.config.map(item => {
                  modules.set(item.path, item)
                })
              }
          
        }
      })
      for (let [key, value] of modules) {
        result.push(value)
      }
      return result
    },
    
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", [
      "setDrawer",
      "toggleDrawer",
      "setPendingRequests",
      "setShowChat"
    ]),
    moduleHasMenu(module) {
      if (module.public_config.admin_left_menu) return true
      return false
    },
    onResponsiveInverted() {
      if (window.innerWidth < 1367) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  }
};
</script>

<style lang="scss">
#app-drawer {
  .theme--light {
      color: #96a2ae!important;
      svg {
        fill: #96a2ae!important;
      }
  } 
  .theme--dark {
      svg {
        fill: #fff!important;
      }
  } 
  .v-image__image--contain {
    top: 16px;
    height: 60%;
  }

  .v-list-item {
    max-height: 52px;
  }

  div.v-responsive.v-image > div.v-responsive__content {
    overflow-y: auto;
  }
  .v-list-item__icon {
      margin-right: 15px;
      margin-top: 12px;
      margin-bottom: 12px;
  }
}
</style>
